import { Component, OnInit, ViewContainerRef, ElementRef, ViewChild, HostListener } from '@angular/core';
import { ImageProcessingStage, PhotoService } from '../../_services/photo.service';
import { Validators, FormBuilder, FormGroup, ValidatorFn, AbstractControl } from '@angular/forms';
import bwipjs from 'bwip-angular2';
import { ActivatedRoute, Router } from '@angular/router';
import { CouponService } from '../../../../src/app/_services/coupon.service';
import { Coupon } from '../../../app/_models/Coupon';
import { NgxSpinnerService } from 'ngx-spinner';
import { DialogService } from '../../../app/_services/dialog.service';
import { map, mergeMap } from 'rxjs/operators'
import { DatePipe } from '@angular/common';
import { combineLatest } from 'rxjs';
import { BsModalService } from 'ngx-bootstrap/modal';
import { CouponPreviewModalComponent } from './coupon-preview-modal.component';
import {isEarlierThanTodayValidator} from "../../_services/date-picker-validator.service";
import {AuthService} from "../../_services/auth.service";

@Component({
  selector: 'app-coupon-form',
  templateUrl: './coupon-form.component.html',
  styleUrls: ['./coupon-form.component.css'],
})

export class CouponFormComponent implements OnInit {

  public form: FormGroup;
  public timeZones = [];
  public loadingMessage = 'Loading coupon data...';

  public couponTitleFocus = false;
  public offerFocus = false;
  public providerFocus = false;
  public expirationDateFocus = false;
  public uploadIconFocus = false;
  public uploadLogoFocus = false;
  public uploadStripFocus = false
  public barcodeFocus = false;

  public fieldDescriptions = {
    couponTitle: "The title of the offer, such as \"20% off any t-shirt.\" Recommended maximum length is 60 characters to ensure full text is displayed on smaller screens.",
    offer: "The details of the offer. Appears on Apple wallet coupon",
    provider: "Required. The offer provider. Recommended maximum length is 12 characters to ensure full text is displayed on smaller screens.",
    labelColor: "Color of all texts on the coupon",
    backgroundColor: "The background color for the coupon. If not set the dominant color of the main image is used, and if no main image is set, the dominant color of the logo is used",
    expire: "Date the coupon expires.",
    iconLarge: "Appears on top of the google pay coupon",
    logoLarge: "Appears on the left corner of apple wallet coupon",
    stripLarge: "Image displayed on the front of the coupon. The image will display at 100% width for the Apple coupon.",
    barcodeMessage: "The destination for coupon. A website URL or coupon ID",
    barcodeType: "Controls how the barcode appears on the coupon. Only appears on the Apple coupon."
  }

  public focusedControl: string = null;

  public previewMode = 'Apple';

  public currentWindowWidth: number;

  public coupon: Coupon = {
    id: null,
    backgroundColor: '#E18E3E',
    labelColor: '#FFFFFF',
    barcodeMessage: '',
    logoLarge: '',
    iconLarge: '',
    stripLarge: '',
    logoSmall: '',
    iconSmall: '',
    stripSmall: '',
    expirationInterval: {
      startDate: new Date(Date.now()),
      endDate: new Date(Date.now())
    },
    timeZone: '0',
    barcodeType: 'None',
    offer: 'Buy one New 20oz Coke Orange Vanilla, get one free.',
    provider: 'Distributer Company, LLC',
    // Fields Relevant for google coupons only
    couponWalletId: null,
    couponTitle: '20% off one bacon fat latte',
    couponDisclaimer: 'Valid at Participating locations.\n\nCoupon values are as specified on the coupon.\n\nLimit of one coupon per customer.\n\nCoupons are intended for single use only.\n\nEach coupon is valid for a limited time only and expires on the date specified in the offer.\n\nWe reserve the right to modify or cancel coupons at any time.',
  };

  public barcodeTypeList = [
    {
      label: 'QR',
      key: 'qrcode'
    },
    {
      label: 'Aztec',
      key: 'azteccode'
    },
    {
      label: 'PDF417',
      key: 'pdf417'
    },
    {
      label: 'CODE 128',
      key: 'CODE_128'
    }
  ];

  public imgUrl = '';
  public loadingLogo = false;
  public loadingStrip = false;
  public loadingIcon = false;
  public formLoaded: boolean;

  @ViewChild('barcodeImage')
  barImg: ElementRef;

  constructor(private fb: FormBuilder,
    private photoService: PhotoService,
    public viewRef: ViewContainerRef,
    private activatedRoute: ActivatedRoute,
    private couponService: CouponService,
    private spinner: NgxSpinnerService,
    private dialogService: DialogService,
    private datePipe: DatePipe,
    private router: Router,
    private modalService: BsModalService,
    private authService: AuthService,
  ) { }

  compare(val1, val2) {
    return val1 === val2;
  }

  ngOnInit () {

    this.currentWindowWidth = window.innerWidth;

    if (this.currentWindowWidth < 1275) {

      this.previewMode = 'Modal';
    }

    this.loadingMessage = 'Loading coupon data...';
    this.spinner.show();

    this.activatedRoute.params
      .subscribe(
        params => {

          const id = params['id'];

          this.authService.getAvailableTimeZones().subscribe(data => {
            this.timeZones = data;
          });

          if (id) {

            this.couponService.getCoupon(id)
              .subscribe(
                data => {

                  this.initializeForm(data);

                  // Adding the validator here in case there are old coupons with barcode messages that will immediately fail validation
                  //this.form.controls.barcodeMessage.setValidators(this.barcodeMessageValidator());
                  //this.form.controls.barcodeMessage.updateValueAndValidity();

                  this.generate(this.form.get('barcodeType').value);
                  this.spinner.hide();
                  this.formLoaded = true;
                },
                err => {

                  console.log(err);
                },
                () => {

                  this.spinner.hide();
                }
              );

          } else {

            const siteUrl = location.origin;

            this.coupon.logoLarge = siteUrl + '/assets/site/media/img/misc/pilot.png'
            this.coupon.stripLarge = siteUrl + '/assets/site/media/img/misc/coke.png'
            this.coupon.iconLarge = siteUrl + '/assets/site/media/img/misc/heart.png'

            const today = this.coupon.expirationInterval.startDate;
            this.coupon.expirationInterval.endDate.setDate(today.getDate() + 1);

            this.initializeForm(this.coupon);

            //this.form.controls.barcodeMessage.setValidators(this.barcodeMessageValidator());
            //this.form.controls.barcodeMessage.updateValueAndValidity();

            this.generate(this.form.get('barcodeType').value);
            this.spinner.hide();
            this.formLoaded = true;
          }
        }
    );

    this.showAlert();
  }

  noDefaultSelectedValidator(control: AbstractControl) {
    return control.value === '0'
      ? { invalidDefault: true }
      : null;
  }

  logoHandler(files: FileList) {

    if (files.length > 0) {

      const file = files[0];
      this.loadingLogo = true;

      if (file.type === 'image/png') {

        this.form.controls.logoSmall.setErrors(null);
      } else {

        this.form.controls.logoSmall.setErrors({incorrectFile: true});
        this.loadingLogo = false;
        return;
      }

      this.spinner.show();

      this.photoService.meetsImageConstraints(file, 280, 120)
        .subscribe(
          result => {

            if (result) {

              const smallObs = this.photoService.enqueueUploadPhoto(file, 'logo-image-small', { height: 60, width: 140 }, false, true);
              const largeObs = this.photoService.enqueueUploadPhoto(file, 'logo-image-large', { height: 120, width: 280 }, false, true);

              combineLatest([smallObs, largeObs])
                .subscribe(
                  data => {

                    this.form.patchValue({ logoSmall: data[0].url });
                    this.form.patchValue({ logoLarge: data[1].url });

                    this.form.markAsDirty();
                    this.loadingLogo = false;

                    if (data[0].stage === ImageProcessingStage.Resized && data[1].stage === ImageProcessingStage.Resized) {

                      this.spinner.hide();
                    }
                  },
                  error => {

                    this.spinner.hide();
                    this.dialogService.alert("Uh oh!", "Something went wrong trying to resize that image. Please try again. Please contact support@connectwithcue.com if you continue to encounter this error.", this.viewRef);
                  }
                );

            } else {

              this.spinner.hide();
              this.form.controls.logoSmall.setErrors({ incorrectFile: true });
              this.form.controls.logoSmall.markAsTouched();
            }
          }
        );
    }
  }

  createOrUpdateCoupon () {

    this.loadingMessage = this.coupon.id ? 'Updating coupon...' : 'Creating coupon...';
    this.spinner.show();

    this.photoService
      .commitUploads()
      .pipe(mergeMap(
        () => {

          const data = Object.assign({}, this.form.value);
          const endDate = data.expire;
          data.expire = { endDate: endDate, startDate: new Date(Date.now()) };

          return this.couponService.createCoupon(data);
        }
      ))
      .subscribe(
        () => {

          this.spinner.hide();

          this.dialogService
            .alert(
              'Ready to go!',
              this.coupon.id
                ? 'Your coupon has been updated! Please note that your changes will only be applied to every coupon distributed from this point on. Already-distributed coupons will not reflect this change'
                : 'Your coupon has been created! You can now distribute this coupon using any of our fan engagement services. Simply create your service, and choose this coupon from the drop-down menu'
            , this.viewRef)
            .then(
              () => {

                this.form.markAsPristine();
                this.router.navigate(['/portal/coupons']);
              }
            );
        },
        err => {

          this.spinner.hide();
          this.dialogService.error(err, 'We were unable to process your request at this time, please try again in a few moments. Please contact CUE support at support@connectwithcue.com if you continue to experience issues', this.viewRef);
          console.log(err);
        }
      );
  }

  stripHandler(files: FileList) {

    if (files.length > 0) {

      const file = files[0];
      this.loadingStrip = true;

      if (file.type === 'image/png') {

        this.form.controls.stripSmall.setErrors(null);

      } else {

        this.form.controls.stripSmall.setErrors({incorrectFile: true});
        this.loadingStrip = false;
        return;
      }

      this.spinner.show();

      this.photoService.meetsImageConstraints(file, 620, 288)
        .subscribe(
          result => {

            if (result) {

              const smallObs = this.photoService.enqueueUploadPhoto(file, 'strip-image-small', { height: 144, width: 310 }, false, true);
              const largeObs = this.photoService.enqueueUploadPhoto(file, 'strip-image-large', { height: 288, width: 620 }, false, true);

              combineLatest([smallObs, largeObs])
                .subscribe(
                  data => {

                    this.form.patchValue({ stripSmall: data[0].url });
                    this.form.patchValue({ stripLarge: data[1].url });

                    this.form.markAsDirty();
                    this.loadingStrip = false;

                    if (data[0].stage === ImageProcessingStage.Resized && data[1].stage === ImageProcessingStage.Resized) {

                      this.spinner.hide();
                    }
                  },
                  error => {

                    this.spinner.hide();
                    this.dialogService.alert("Uh oh!", "Something went wrong trying to resize that image. Please try again. Please contact support@connectwithcue.com if you continue to encounter this error.", this.viewRef);
                  }
                );

            } else {

              this.spinner.hide();
              this.form.controls.stripSmall.setErrors({incorrectFile: true});
              this.form.controls.stripSmall.markAsTouched();
            }
          }
        );
    }
  }

  iconHandler(files: FileList) {

    if (files.length > 0) {

      const file = files[0];
      this.loadingIcon = true;

      if (file.type === 'image/png') {

        this.form.controls.iconSmall.setErrors(null);

      } else {

        this.form.controls.iconSmall.setErrors({incorrectFile: true});
        this.loadingIcon = false;
        return;
      }

      this.spinner.show();

      this.photoService.meetsImageConstraints(file, 58, 58)
        .subscribe(
          result => {
            console.log('check constraints');
            if (result) {

              const smallObs = this.photoService.enqueueUploadPhoto(file, 'icon-image-small', { height: 29, width: 29 }, false, true);
              const largeObs = this.photoService.enqueueUploadPhoto(file, 'icon-image-large', { height: 58, width: 58 }, false, true);

              combineLatest([smallObs, largeObs])
                .subscribe(
                  data => {

                    this.form.patchValue({ iconSmall: data[0].url });
                    this.form.patchValue({ iconLarge: data[1].url });

                    this.form.markAsDirty();
                    this.loadingIcon = false;

                    if (data[0].stage === ImageProcessingStage.Resized && data[1].stage === ImageProcessingStage.Resized) {

                      this.spinner.hide();
                    }
                  },
                  error => {

                    this.spinner.hide();
                    this.dialogService.alert("Uh oh!", "Something went wrong trying to resize that image. Please try again. Please contact support@connectwithcue.com if you continue to encounter this error.", this.viewRef);
                  }
                );

            } else {

              this.spinner.hide();
              this.form.controls.iconSmall.setErrors({incorrectFile: true});
              this.form.controls.iconSmall.markAsTouched();
            }
          }
        );
    }
  }

  generate (type) {

    this.form.controls.barcodeMessage.updateValueAndValidity();

    if (type === 'Aztec') {

      type = 'azteccode';

    } else if (type === 'QR') {

      type = 'qrcode';

    } else if (type === 'CODE_128') {

      type = 'code128';

    } else if (type === 'None') {

      this.imgUrl = '';
      return;
    }

    const canvas = document.createElement('canvas');

    bwipjs(canvas, {
      bcid: type.toLowerCase(),
      text: this.form.get('barcodeMessage').value || " ",
      scale: 3,               // 3x scaling factor
      height: 10,              // Bar height, in millimeters
      includetext: type !== 'code128',            // Show human-readable text only if not code 128
      textxalign: 'center',        // Always good to set this
    }, (err, cvs) => {

      if (err) {

        console.log(err);

      } else {

        if (this.barImg) {

          this.barImg.nativeElement.src = canvas.toDataURL('image/png');
        }

        this.imgUrl = canvas.toDataURL('image/png');
      }
    });
  }

  cancel() {
    this.router.navigate(['/portal/coupons']);
  }

  private initializeForm (coupon: Coupon) {

    this.coupon = coupon;
    const couponWalletId = coupon.couponWalletId ? coupon.couponWalletId : this.generateUUID();

    this.form = this.fb.group({
      id: coupon?.id,
      backgroundColor: [coupon.backgroundColor, [Validators.required]],
      labelColor: [coupon.labelColor, [Validators.required]],
      barcodeMessage: [coupon.barcodeMessage],
      logoSmall: [coupon.logoSmall, [Validators.required]],
      iconSmall: [coupon.iconSmall, [Validators.required]],
      stripSmall: [coupon.stripSmall, [Validators.required]],
      logoLarge: [coupon.logoLarge, [Validators.required]],
      iconLarge: [coupon.iconLarge, [Validators.required]],
      stripLarge: [coupon.stripLarge, [Validators.required]],
      expire: [this.datePipe.transform(coupon.expirationInterval.endDate, 'yyyy-MM-dd'), [Validators.required, isEarlierThanTodayValidator(new Date(Date.now()))]],
      timeZone: [coupon.timeZone || "0", [Validators.required, this.noDefaultSelectedValidator]],
      barcodeType: [coupon.barcodeType],
      provider: [coupon.provider, [Validators.required]],
      offer: [coupon.offer, [Validators.required]],
      // fields relevant for google coupons only
      couponWalletId: [couponWalletId],
      couponTitle: [coupon.couponTitle , [Validators.maxLength(40)]],
      couponDisclaimer: [coupon.couponDisclaimer],
    });

    this.form.markAllAsTouched();
  }

  barcodeMessageValidator () : ValidatorFn {

    return (control: AbstractControl) : { [key: string]: any } | null => {

      if (this.form) {

        const value = control.value;

        if (this.form.controls.barcodeType?.value !== 'None') {

          const urlRegex = new RegExp(/https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/gm);

          if (!urlRegex.test(value)) {

            return { "invalidUrl": { value: control.value } }
          }

        } else {

          return null;
        }
      }
    }
  }

  openPreviewModal () {

    const modalConfig = {
      backdrop: true,
      ignoreBackdropClick: true
    };

    const initialState = {
        form: this.form,
        imgUrl: this.imgUrl
    };

    this.modalService
        .show(
            CouponPreviewModalComponent,
            Object.assign({}, modalConfig, { class: 'modal-md', initialState }));
  }

  /* eslint-disable no-bitwise */
  // algorithm taken from https://stackoverflow.com/a/8809472
  private generateUUID() { // Public Domain/MIT
    let d = new Date().getTime(); // Timestamp
    let d2 = (performance && performance.now && (performance.now() * 1000)) || 0; // Time in microseconds since page-load or 0 if unsupported
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        let r = Math.random() * 16; // random number between 0 and 16
        if (d > 0) { // Use timestamp until depleted
            r = (d + r) % 16 | 0;
            d = Math.floor(d / 16);
        } else { // Use microseconds since page-load if supported
            r = (d2 + r) % 16 | 0;
            d2 = Math.floor(d2 / 16);
        }
        return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
  }
  /* eslint-enable no-bitwise */

  private showAlert() {
    if (!localStorage.getItem('couponAlertShowed')) {
      this.dialogService.alert(
        '"Best Effort" Notification',
        'The sizing and truncation of coupon fields are controlled by proprietary algorithms in the Passbook app. ' +
        'The rendering you see on the CUE Audio Portal is our best attempt at reverse engineering these algorithms. ' +
        'The actual number of characters that any one field can contain varies from pass type to pass type, and is affected by the content of adjacent fields.',
        this.viewRef
      );

      localStorage.setItem('couponAlertShowed', 'true');
    }
  }

  @HostListener('window:resize')
  onResize () {

    if (this.currentWindowWidth < 1275 && window.innerWidth > 1275) {

      this.previewMode = 'Apple';
    }

    this.currentWindowWidth = window.innerWidth

    if (this.currentWindowWidth < 1275) {

      this.previewMode = 'Modal';
    }
  }

  onDeactivate() {
    this.photoService.clearQueue();
  }
}
